import React, { createContext, useContext } from "react";
import { useIsDesktopViewport } from "../../hooks/useIsDesktopViewport";

/**
 * Desktop navigation grammar.
 *
 *  - Primary destinations (reachable from the persistent sidebar) show NO Back
 *    control: the sidebar is their navigation.
 *  - Drill-down / detail screens show one consistent contextual return:
 *    "‹ {Parent}" (Clients, Projects, Estimates, Administration, ...).
 *  - Specialized shells (Administration) keep their own sidebar and add an
 *    explicit "‹ CrewPilot" return at the top of it.
 *
 * The provider only carries labels; screens keep their own onBack handlers.
 */
const DesktopNavContext = createContext(null);

export const DesktopNavProvider = DesktopNavContext.Provider;

/** { parentLabel } on a desktop viewport inside a provider, otherwise null (mobile is untouched). */
export function useDesktopNav() {
  const value = useContext(DesktopNavContext);
  const isDesktop = useIsDesktopViewport();
  return isDesktop ? value : null;
}
